export default function Divider({ className = '' }: { className?: string }) {
  return <div className={`h-px w-full bg-neutral-300 dark:bg-neutral-600 ${className}`} />;
}
